import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import customPagesApi from "../admincomponents/CustomPagesApi";
import { BASE_URL } from "../baseurl";
import { resolveAssetUrl } from "../baseurl";
const origin = BASE_URL.replace(/\/api\/?$/, "");
const imageUrl = (value) => value && !value.startsWith("data:") && !value.startsWith("http") && value.startsWith("/uploads/") ? `${origin}${value}` : value;

function RenderBlock({ block }) {
  const settings = block.settings || {};
  const width = settings.width === "full" ? "100%" : settings.width === "wide" ? "80%" : "52%";
  const align = settings.align === "center" ? "center" : settings.align === "right" ? "flex-end" : "flex-start";
  const contentAlign = settings.contentAlign === "center" ? "center" : settings.contentAlign === "right" ? "flex-end" : "flex-start";
  const style = {
    width,
    alignSelf: align,
    background: settings.background && settings.background !== "transparent" ? settings.background : undefined,
    color: settings.textColor || undefined,
    padding: `${settings.paddingY || 16}px ${settings.paddingX || 16}px`,
  };

  if (block.type === "heading") {
    const Tag = block.level || "h2";
    return <Tag style={style} className="text-3xl font-bold text-gray-900">{block.value}</Tag>;
  }
  if (block.type === "text") {
    return <p style={{ ...style, textAlign: contentAlign === "center" ? "center" : contentAlign === "flex-end" ? "right" : "left" }} className="text-gray-700 leading-relaxed whitespace-pre-wrap">{(block.value || "").replace(/<[^>]*>/g, "")}</p>;
  }
  if (block.type === "image" && block.value) {
    return <div style={{ ...style, alignItems: contentAlign }} className="flex flex-col"><img src={resolveAssetUrl(block.value)} alt={block.alt || ""} style={{ width: `${block.imageWidth || 100}%`, height: block.imageHeight ? `${block.imageHeight}px` : "auto" }} className="rounded-xl object-cover" /></div>;
  }
  if (block.type === "spacer") return <div style={{ height: block.height || 48 }} />;
  if (block.type === "columns") {
    return (
      <div style={style} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {(block.columns || []).map((column, index) => column.type === "image" && column.value
          ? <img key={column.id || index} src={resolveAssetUrl(column.value)} alt={column.alt || ""} style={{ width: `${column.imageWidth || 100}%` }} className="rounded-xl object-cover" />
          : <p key={column.id || index} className="text-gray-700 leading-relaxed whitespace-pre-wrap">{(column.value || "").replace(/<[^>]*>/g, "")}</p>)}
      </div>
    );
  }
  return null;
}

export default function LegacyCustomPageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    customPagesApi.get(slug).then((value) => {
      if (value.status !== "Published") return setStatus("not-found");
      setPage(value);
      setStatus("ready");
    }).catch(() => setStatus("not-found"));
  }, [slug]);

  if (status === "loading") return <div className="p-16 text-center text-gray-400 text-sm">Loading...</div>;
  if (status !== "ready") return <Navigate to="/404" replace />;

  return (
    <div className="w-full min-h-screen pt-40 pb-16 px-6" style={{ background: page.background || "#fff" }}>
      <div className="max-w-4xl mx-auto flex flex-col gap-6">
        {(page.content || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0)).map((block) => <RenderBlock key={block.id} block={block} />)}
      </div>
    </div>
  );
}